import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonInput,
  IonLabel,
  IonModal,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";
import { useRecoilState } from "recoil";
import CreateNewLookup from "../components/modals/create-new-lookup";
import TopLeftUserName from "../components/TopLeftUserName";
import {
  dropDownStateToSave,
  IseditingLookupsState,
  networkConnectionStatus,
  newAllDropDownState,
  PatientState,
} from "../data/atoms";
import { ActionType, Lookups } from "../models/Enums";
import { PatientFormDropdowns } from "../models/PatientFormDropdowns";
import { PatientVM } from "../models/PatientVM";
import {
  EnableDisablePatientRtm,
  GetGeneralLookupData,
  RegisterPatientAuth,
  SaveRecentSearchAuth,
} from "../services/AuthServices";
import {
  CurrDatetimeInNewFormat,
  getPatientIntegrationLock,
  localDateTime,
  numberValidation,
  verifiyNameWithPattern,
} from "../utils/sharedFunction";
import SelectSelectionCustom from "../components/SelectSectionCustom";
import { Option } from "../models/Option";
import TagsName from "../components/TagsName";
import { format, set } from "date-fns";
import ErrorTopToaster from "../components/ErrorTopToaster";
import ExitModal from "../components/modals/exit-modal";
import PatientExistModal from "../components/modals/patient-exist-modal";
import SuccessModal from "../components/modals/success-modal";
import ConsentFormModal from "../components/modals/consent-form-modal";
import ChooseEpisodeModal from "../components/modals/choose-episode-modal";
import NewEpisodeModal from "../components/modals/new-episode-modal";
import RemoteTherapeuticMonitoringModal from "../components/modals/remote-therapeutic-monitoring-modal";
import RtmEnabledModal from "../components/modals/rtm-enabled-modal";
import CompletedEducationModal from "../components/modals/completed-education-modal";
import SetupEpisodeModal from "../components/modals/setup-episode-modal";
import ProactiveYouModal from "../components/modals/ProactiveYouModal";
import PatientRegistrationQRModal from "../components/modals/patient-registeration-qr-modal";

const months = [
  { value: "1", label: "Jan" },
  { value: "2", label: "Feb" },
  { value: "3", label: "Mar" },
  { value: "4", label: "Apr" },
  { value: "5", label: "May" },
  { value: "6", label: "Jun" },
  { value: "7", label: "Jul" },
  { value: "8", label: "Aug" },
  { value: "9", label: "Sep" },
  { value: "10", label: "Oct" },
  { value: "11", label: "Nov" },
  { value: "12", label: "Dec" },
];

const days = Array.from({ length: 31 }, (_, i) => i + 1);
const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 1899 }, (_, i) => 1900 + i);

interface Props {
  props: any;
}
const CreateEditPatient: React.FC<Props> = ({ props }) => {
  const modal = useRef<HTMLIonModalElement>(null);
  let isEdit = props == undefined ? true : props?.props;
  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);
  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);
  const [isTestPatient, setisTestPatient] = useState<boolean>(false);
  const [createPatientStep2, setCreatePatientStep2] = useState<boolean>(false);
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState<PatientFormDropdowns>(newAllDropDownState);
  const [savedDropDowns, setSavedDropDowns] =
    useRecoilState<PatientFormDropdowns>(newAllDropDownState);
  const [DropDownStateToSave, setDropDownStateToSave] =
    useRecoilState(dropDownStateToSave);
  const [cancelModal, setcancelModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [patientExitModal, setPatientExitModal] = useState(false);
  const [lookUpOption, setLookUpOption] = useState<boolean>(false);
  const [lookUpType, setLookUpType] = useState<Lookups>(0);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [errorStringDisplay, seterrorStringDisplay] = useState<string>("");
  const [selectedAccordionValue, setSelectedAccordionValue] =
    useState<string>("");
  const [iseditingLookup, setIseditingLookup] = useRecoilState(
    IseditingLookupsState,
  );
  const [apiReqSent, setApiReqSent] = useState<boolean>(false);
  const [selectedSetting, setSelectedSetting] = useState<any>({});
  const [dropDownErros, setDropDownErros] = useState({
    setting: false,
    tags: false,
    diagnosis: false,
    referral: false,
    physician: false,
    department: false,
    medications: false,
    followUpType: false,
  });

  //States for new date picker
  const [selectedMonth, setSelectedMonth] = useState<number>(1);
  const [selectedDay, setSelectedDay] = useState<number>(1);
  const [selectedYear, setSelectedYear] = useState<number>(1900);
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [isValidDate, setIsValidDate] = useState<boolean>(true);
  const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
  const [isMonthOpen, setIsMonthOpen] = useState<boolean>(false);
  const [isDayOpen, setIsDayOpen] = useState<boolean>(false);
  const [isYearOpen, setIsYearOpen] = useState<boolean>(false);
  const dropdownMonthRef = useRef<HTMLDivElement | null>(null);
  const dropdownDayRef = useRef<HTMLDivElement | null>(null);
  const dropdownYearRef = useRef<HTMLDivElement | null>(null);
  const accordionGroup = useRef<null | HTMLIonAccordionGroupElement>(null);
  const [isOpenRequired, setIsOpenRequired] = useState(false);
  const [isOpenAdditional, setIsOpenAdditional] = useState(false);
  const [isAlreadyClicked, setIsAlreadyClicked] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [ConsentForm, setConsentForm] = useState(false);
  const [selectedTime, setSelectedTime] = useState<string>("");
  const [CompletedEducation, setCompletedEducation] = useState(false);
  const [ChooseEpisode, setChooseEpisode] = useState(false);
  const [NewEpisode, setNewEpisode] = useState(false);
  const [SetupEpisode, setSetupEpisode] = useState(false);
  const [consentFormData, setConsentFormData] = useState<any>(null);

  // RTM State
  const [IsNewEpisode, setIsNewEpisode] = useState(false);
  const [IsRtmReenable, setIsRtmReenable] = useState(false);
  const [RtmEnabled, setRtmEnabled] = useState(false);
  const [openRtmModal, setOpenRtmModal] = useState(false);
  const [RemoteTherapeuticMonitoring, setRemoteTherapeuticMonitoring] =
    useState(false);
  const [isRtmConfigurationEnabled, setIsRtmConfigurationEnabled] =
    useState(false);
  const rtmEnabledRef = useRef(false);

  const [openProactiveAfterClose, setOpenProactiveAfterClose] = useState(false);
  const [proactiveYouModal, setProactiveYouModal] = useState(false);

  const [registerPatientModal, setRegisterPatientModal] = useState(false);

  const handleAccordionChange = (value: string) => {
    debugger;
    if (value === "requiredInfo") {
      setIsOpenAdditional(!isOpenAdditional ? true : false);
      setIsOpenRequired(isOpenRequired ? !isOpenRequired : true);
    } else if (value === "additionalInfo") {
      setIsOpenAdditional(isOpenAdditional ? !isOpenAdditional : true);
      setIsOpenRequired(!isOpenRequired ? true : false);
    }
    setSelectedAccordionValue(value === selectedAccordionValue ? "" : value);
  };

  // Calculate the number of days in a month, considering leap years
  const getDaysInMonth = (year: number, month: number) => {
    if (month == 2) {
      return isLeapYear(year) ? 29 : 28;
    }

    return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];
  };

  // Check if a year is a leap year or not
  const isLeapYear = (year: number) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };

  // Check for specific date validity, for example, avoiding Feb 30 or April 31
  const checkValidDate = () => {
    if (
      selectedDay > 0 &&
      selectedDay <= getDaysInMonth(selectedYear, selectedMonth)
    ) {
      return true;
    } else {
      return false;
    }
  };

  //Function called whenever a date field is changed to validate the date
  const validDate = () => {
    const todayDate = new Date();
    const givenMonth = selectedMonth;
    const date = new Date(selectedYear, givenMonth - 1, selectedDay);

    if (date > todayDate) {
      setIsValidDate(false);
      return;
    }

    // Check if the date is valid
    if (!isNaN(date.getTime()) && checkValidDate()) {
      // Perform actions with the valid date
      setIsValidDate(true);
      setSelectedDate(date);
      return true;
    } else {
      // Perform actions for an invalid date
      setIsValidDate(false);
      return false;
    }
  };

  const handleMonthChange = (event: any) => {
    setIsFirstTime(false);
    setSelectedMonth(event);
  };

  const handleDayChange = (event: any) => {
    setIsFirstTime(false);
    setSelectedDay(event);
  };

  const handleYearChange = (event: any) => {
    setIsFirstTime(false);
    setSelectedYear(event);
  };

  const handleMonthClickOutside = (event: any) => {
    if (
      dropdownMonthRef.current &&
      !dropdownMonthRef.current.contains(event.target as Node)
    ) {
      setIsMonthOpen(false);
    }
  };

  const handleDayClickOutside = (event: any) => {
    if (
      dropdownDayRef.current &&
      !dropdownDayRef.current.contains(event.target as Node)
    ) {
      setIsDayOpen(false);
    }
  };

  const handleYearClickOutside = (event: any) => {
    if (
      dropdownYearRef.current &&
      !dropdownYearRef.current.contains(event.target as Node)
    ) {
      setIsYearOpen(false);
    }
  };

  const toggleMonthDropdown = () => {
    setIsMonthOpen(!isMonthOpen);
  };

  const toggleDayDropdown = () => {
    setIsDayOpen(!isDayOpen);
  };

  const toggleYearDropdown = () => {
    setIsYearOpen(!isYearOpen);
  };

  useEffect(() => {
    validDate();
  }, [selectedYear, selectedMonth, selectedDay]);

  useEffect(() => {
    document.addEventListener("click", handleMonthClickOutside);
    return () => {
      document.removeEventListener("click", handleMonthClickOutside);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleDayClickOutside);
    return () => {
      document.removeEventListener("click", handleDayClickOutside);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleYearClickOutside);
    return () => {
      document.removeEventListener("click", handleYearClickOutside);
    };
  }, []);

  // Clear error message after 5 seconds
  useEffect(() => {
    if (errorStringDisplay) {
      const timer = setTimeout(() => {
        seterrorStringDisplay("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorStringDisplay]);

  let location =
    window.location.href == window.location.origin + "/create-edit-patient"
      ? true
      : false;
  let history = useHistory();

  const patientIntegrationLock = getPatientIntegrationLock(patientDetails);

  // First name / last name / DOB / mobile phone
  const disableIdentityFields =
    isEdit && patientIntegrationLock.disableIdentityFields;

  // Email (and admit/discharge/room when they exist on this screen)
  const disableIntegrationOnlyFields =
    isEdit && patientIntegrationLock.disableIntegrationOnlyFields;

  const {
    register,
    setError,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<PatientVM>({
    defaultValues: {
      ...patientDetails,
      dobFormatted: isEdit
        ? format(new Date(patientDetails?.dob), "MM/dd/yyyy")
        : "",
    },
  });

  // Register your dropdown field with React Hook Form
  const { ref, ...selectProps } = register("settingFormField", {
    required: "Setting is mandatory.", // Add validation rules if needed
  });

  //To set the date in the date picker in case of edit
  const formatDate = (patientDetails: any) => {
    const dateObject = new Date(patientDetails.dob);
    const selectedMonth = dateObject.getMonth() + 1; // Months are zero-based, so add 1
    const selectedDay = dateObject.getDate();
    const selectedYear = dateObject.getFullYear();
    setSelectedMonth(selectedMonth);
    setSelectedDay(selectedDay);
    setSelectedYear(selectedYear);
  };

  //To call format function in case of edit
  useEffect(() => {
    if (isEdit) {
      console.log("patientDetails in edit", patientDetails);
      formatDate(patientDetails);
      setValue("settingFormField", newAllDropDown.setting); // Set the value of the dropdown field
    }
  }, [isEdit]);

  useEffect(() => {
    initializeAllArrays();

    if (isEdit && patientDetails !== null && patientDetails !== undefined) {
      setisTestPatient(patientDetails!?.isTestPatient);
      // setPatientDetails(patientDetailsRecoil);
      setIsDisabled(false);
    }
    setIsOpenRequired(true);
    setIsOpenAdditional(false);

    const rtmEnabled = localStorage.getItem("isRtmEnabled") === "true";
    setIsRtmConfigurationEnabled(rtmEnabled);
    rtmEnabledRef.current = rtmEnabled;
    return () => {
      setValue("dobFormatted", "");
      setValue("dob", "");
      reset();
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        ...newAllDropDownState,
      }));
    };
  }, [location]);

  async function initializeAllArrays() {
    debugger;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    await GetGeneralLookupData({
      localDateTime: new Date(),
      returnReferrals: true,
      returnDepartment: true,
      returnPhysician: true,
      returnTags: true,
      returnDiagnosis: true,
      returnPatientSettings: true,
      clinicianRole: false,
      returnMedications: true,
      returnMobilities: false,
      returnFollowUpTypes: true,
    })
      .then(async function (response) {
        if (response!.data.responseCode === 1) {
          await getResponseSetupDropDown(response!.data);
          setIsDisabled(false);
        } else {
        }
      })
      .catch((error) => {
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
      });
  }

  const getResponseSetupDropDown = (response: any) => {
    debugger;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setSavedDropDowns((prevState: PatientFormDropdowns) => ({
      ...prevState,
      settingOpt: response.patientsSettings,
      departmentOpt: response.departments.reverse(),
      physicianOpt: response.physicians.reverse(),
      referralOpt: response.referrals.reverse(),
      tagsOpt: response.tags.reverse(),
      diagnosisOpt: response.diagnosis,
      medicationsOpt: response.medications,
      followUpTypesOpt: response.followUpTypes,
      setting:
        patientDetails?.patientSetting !== 6
          ? response.patientsSettings.find(
              (setting: any) => setting.id == patientDetails.patientSetting,
            )
          : newAllDropDown?.setting,
      tags: newAllDropDown?.tags?.length
        ? [
            ...newAllDropDown.tags.map((tag: any) => {
              return response?.tags?.find((patTag: any) => {
                if (tag?.id == patTag?.id) return { ...tag, name: patTag.name };
              });
            }),
          ]
        : patientDetails?.tagIds !== null && patientDetails?.tagIds.length
          ? [
              ...response.tags.filter((tag: any) => {
                return patientDetails?.tagIds.find((patTag: any) => {
                  if (tag.id == patTag) return tag;
                });
              }),
            ]
          : [],
      diagnosis: newAllDropDown?.diagnosis?.length
        ? [
            ...newAllDropDown.diagnosis.map((Diag: any) => {
              return response?.diagnosis?.find((DiagTag: any) => {
                if (Diag?.id == DiagTag?.id)
                  return { ...Diag, name: DiagTag.name };
              });
            }),
          ]
        : patientDetails?.diagnosisIds !== null &&
            patientDetails?.diagnosisIds.length
          ? [
              ...response.diagnosis.filter((diagnosis: any) => {
                return patientDetails?.diagnosisIds.find(
                  (patDiagnosis: any) => {
                    if (diagnosis.id == patDiagnosis) return diagnosis;
                  },
                );
              }),
            ]
          : [],
      referral:
        patientDetails?.referralId !== null && patientDetails?.referralId !== -1
          ? response.referrals.find(
              (referral: any) => referral.id == patientDetails.referralId,
            )
          : {
              id: undefined,
              isDefault: undefined,
              isSelected: undefined,
              name: undefined,
            },
      physician:
        patientDetails?.physicianId !== null &&
        patientDetails?.physicianId !== -1
          ? response.physicians.find(
              (physician: any) => physician?.id == patientDetails.physicianId,
            )
          : {
              id: undefined,
              isDefault: undefined,
              isSelected: undefined,
              name: undefined,
            },
      department:
        patientDetails?.departmentId !== null &&
        patientDetails?.departmentId !== -1
          ? response.departments.find(
              (department: any) => department.id == patientDetails.departmentId,
            )
          : {
              id: undefined,
              isDefault: undefined,
              isSelected: undefined,
              name: undefined,
            },

      medications: newAllDropDown?.medications?.length
        ? [
            ...newAllDropDown?.medications?.map((medicine: any) => {
              return response?.medications?.find((DiagMedicine: any) => {
                if (medicine?.id == DiagMedicine?.id)
                  return { ...medicine, name: DiagMedicine.name };
              });
            }),
          ]
        : patientDetails?.medicationIds !== null &&
            patientDetails?.medicationIds.length
          ? [
              ...response.medications.filter((medicine: any) => {
                return patientDetails?.medicationIds.find(
                  (patMedicine: any) => {
                    if (medicine.id == patMedicine) return medicine;
                  },
                );
              }),
            ]
          : [],
      followUpType:
        patientDetails?.followUpTypeId !== null &&
        patientDetails?.followUpTypeId !== -1
          ? response.followUpTypes.find(
              (followUpType: any) =>
                followUpType.id == patientDetails.followUpTypeId,
            )
          : {
              id: undefined,
              isDefault: undefined,
              isSelected: undefined,
              name: undefined,
            },
    }));
  };

  const namingtValidation = (e: Event, name: any) => {
    debugger;
    clearErrors(name);
    let verifyName = verifiyNameWithPattern(
      (e.target as HTMLInputElement).value,
    );
    if (!verifyName.isSuccess) {
      setError(name, {
        type: "validate",
        message: verifyName.error.replace("Data", name.replace("Name", "")),
      });
    } else {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        [String(name)]: (e.target as HTMLInputElement).value,
      }));
    }
  };

  const dobValidation = (e: Event) => {
    debugger;
    clearErrors("dobFormatted");
    clearErrors("dob");
    let targetElement = e.target as HTMLInputElement;
    if (
      (targetElement.value.length != 0 ||
        patientDetails?.dobFormatted?.length! == 1) &&
      targetElement.value.length <= 10
    ) {
      if (
        targetElement.value.length == 2 &&
        patientDetails?.dobFormatted?.indexOf("/") == -1
      ) {
        (e.target as HTMLInputElement).value = targetElement.value + "/";
      } else if (
        targetElement.value.length == 5 &&
        patientDetails?.dobFormatted?.lastIndexOf("/") == 2
      ) {
        (e.target as HTMLInputElement).value = targetElement.value + "/";
      }
      setPatientDetails((prevState: any) => ({
        ...prevState,
        dobFormatted: targetElement.value,
      }));
    } else {
      ((e.target as HTMLInputElement).value as String) =
        patientDetails?.dobFormatted as String;
    }
  };

  const inputNumberVerify = (e: Event, inputField: any) => {
    clearErrors(inputField);
    let verifyZpCode = numberValidation((e.target as HTMLInputElement).value);
    if (!verifyZpCode.isSuccess) {
      setError(inputField, {
        type: "pattern",
        message: ` ${inputField == "zip" ? "Zip Code" : "MRN"}  ${
          verifyZpCode.error
        }`,
      });
    }
  };

  function validateDate(dateOfBirthVal: any) {
    if (dateOfBirthVal.includes("T")) {
      dateOfBirthVal = format(new Date(dateOfBirthVal), "MM/dd/yyyy");
    }
    let newDate = new Date();
    let presentDate = newDate.getDate();
    let presentMonth = newDate.getMonth();
    let presentYear = newDate.getFullYear();
    if (dateOfBirthVal == null) {
      return false;
    }
    let pattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/\d{4}$/;

    let isNameValid = pattern.test(dateOfBirthVal);
    if (!isNameValid) {
      setError("dob", {
        type: "validate",
        message: "Enter DOB in MM-DD-YYYY format",
      });
      return false;
    }

    // let dateValues = dateOfBirthVal.match(pattern);
    let dateValues = dateOfBirthVal.split("/");
    if (dateValues == null) {
      setError("dob", { type: "validate", message: "Invalid date of birth" });
      return false;
    }
    let birthYear = dateValues[2];
    let birthMonth = dateValues[0];
    let birthDate = dateValues[1];
    if (birthMonth < 1 || birthMonth > 12) {
      setError("dob", { type: "validate", message: "Invalid date of birth" });
      return false;
    } else if (birthDate < 1 || birthDate > 31) {
      setError("dob", { type: "validate", message: "Invalid date of birth" });
      return false;
    } else if (
      (birthMonth == 4 ||
        birthMonth == 6 ||
        birthMonth == 9 ||
        birthMonth == 11) &&
      birthDate == 31
    ) {
      setError("dob", { type: "validate", message: "Invalid date of birth" });
      return false;
    } else if (birthYear > presentYear) {
      setError("dob", { type: "validate", message: "Invalid date of birth" });
      return false;
    } else if (birthYear == presentYear) {
      if (birthMonth > presentMonth + 1) {
        setError("dob", { type: "validate", message: "Invalid date of birth" });
        return false;
      } else if (birthMonth == presentMonth + 1) {
        if (birthDate > presentDate) {
          setError("dob", {
            type: "validate",
            message: "Invalid date of birth",
          });
          return false;
        }
      }
    }
    return true;
  }

  const RegisterPatientStep1 = (data: any) => {
    if (!isAlreadyClicked) {
      setIsAlreadyClicked(true);
      if (newAllDropDown.setting) {
        clearErrors("settingFormField");
      }
      if (!navigator.onLine) {
        setShowNetWorkRecoil({ isShown: true });
        setIsAlreadyClicked(false);
        return;
      }
      data.dobFormatted = `${selectedMonth
        .toString()
        .padStart(2, "0")}/${selectedDay
        .toString()
        .padStart(2, "0")}/${selectedYear.toString()}`;

      if (
        checkDropDownValidation() &&
        validateDate(data.dobFormatted!) &&
        Object.keys(errors).length == 0
      ) {
        setIsDisabled(false);
        RegisterPatientStep2(data);
        setCreatePatientStep2(true);
      } else {
        setIsAlreadyClicked(false);
        setIsDisabled(true);
      }
    }
  };

  const getLookUp = (type: String) => {
    if (type == "Setting") {
      return Lookups.Setting;
    } else if (type == "Department") {
      return Lookups.Department;
    } else if (type == "Physician") {
      return Lookups.Physician;
    } else if (type === "Referral") {
      return Lookups.Referral;
    } else if (type === "Tags") {
      return Lookups.Tags;
    } else if (type === "Diagnosis") {
      return Lookups.Diagnosis;
    } else if (type === "Role") {
      return Lookups.Role;
    } else if (type === "Medications") {
      return Lookups.Medications;
    } else if (type === "Mobility") {
      return Lookups.Mobilities;
    } else if (type === "FollowUpType") {
      return Lookups.FollowUpType;
    } else {
      return Lookups.Other;
    }
  };

  const setLookUp = (edit: boolean, id: number, name: any, type: String) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    let LookupId: Lookups = 0;
    LookupId = getLookUp(type);
    setLookUpType(LookupId);
    setIseditingLookup((prevState: any) => ({
      ...prevState,
      IseditingLookups: edit,
      Id: id,
      Label: name,
      LookUp: LookupId,
    }));
    setLookUpOption(true);
  };

  function removeDuplicate(obj: any) {
    let ids = obj.map((o: any) => o.id);
    return obj.filter(
      ({ id }: any, index: any) => !ids.includes(id, index + 1),
    );
  }

  const dropDownSelections = (option: any, tagName: any) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    let removeDuplication: Option[] = [];
    let isAlreadyExist: boolean = false;

    // setValue("settingFormField", option); // Set the value of the dropdown field

    if (errors.settingFormField) {
      clearErrors("settingFormField");
    }

    if (
      tagName !== "VisitType" &&
      tagName !== "Tags" &&
      tagName !== "Diagnosis" &&
      tagName !== "Medications"
    ) {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        [tagName.toLowerCase()]: option,
      }));

      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        [tagName.toLowerCase() + "Id"]: option.id,
      }));
    } else if (
      tagName === "Tags" ||
      tagName === "Diagnosis" ||
      tagName === "Medications"
    ) {
      if (tagName === "Tags") {
        if (newAllDropDown.tags.some((tag: Option) => tag.id === option.id)) {
          removeDuplication = newAllDropDown.tags.filter(
            (obj: Option) => obj.id != option.id,
          );

          isAlreadyExist = true;
        } else {
          removeDuplication = removeDuplicate([...newAllDropDown.tags, option]);
        }
      } else if (tagName === "Diagnosis") {
        if (
          newAllDropDown.diagnosis.some((diag: Option) => diag.id === option.id)
        ) {
          removeDuplication = newAllDropDown.diagnosis.filter(
            (obj: Option) => obj.id != option.id,
          );

          isAlreadyExist = true;
        } else {
          removeDuplication = removeDuplicate([
            ...newAllDropDown.diagnosis,
            option,
          ]);
        }
      } else if (tagName === "Medications") {
        if (
          newAllDropDown.medications.some((med: Option) => med.id === option.id)
        ) {
          removeDuplication = newAllDropDown.medications.filter(
            (obj: Option) => obj.id != option.id,
          );

          isAlreadyExist = true;
        } else {
          removeDuplication = removeDuplicate([
            ...newAllDropDown.medications,
            option,
          ]);
        }
      }

      setNewAllDropDown((lp: PatientFormDropdowns) => {
        return {
          ...lp,
          [tagName.toLowerCase()]: [...removeDuplication],
        };
      });
    }

    if (tagName === "Setting") {
      debugger;
      setValue("settingFormField", option); // Set the value of the dropdown field
      setDropDownErros((prevState: any) => ({
        ...prevState,
        setting: false,
      }));
      setIsDisabled(false);

      setSelectedSetting(option);
    }

    if (tagName === "FollowUpType") {
      setNewAllDropDown((prevState: PatientFormDropdowns) => ({
        ...prevState,
        followUpType: option,
      }));

      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        followUpTypeId: option.id,
      }));
    }

    if (tagName === "Tags" && isAlreadyExist) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        tagIds: [
          ...removeDuplication.map((opt: Option) => {
            return opt.id;
          }),
        ],
      }));
    } else if (tagName === "Diagnosis" && isAlreadyExist) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        diagnosisIds: [
          ...removeDuplication.map((opt: Option) => {
            return opt.id;
          }),
        ],
      }));
    } else if (tagName === "Medications" && isAlreadyExist) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        medicationIds: [
          ...removeDuplication.map((opt: Option) => {
            return opt.id;
          }),
        ],
      }));
    }
  };

  const checkDropDownValidation = () => {
    if (
      newAllDropDown.setting == undefined ||
      newAllDropDown.setting?.id == undefined
    ) {
      setDropDownErros((prevState: any) => ({
        ...prevState,
        setting: true,
      }));
      setErrorModal(true);
      return false;
    } else {
      return true;
    }
  };

  const dismissModal = async (boolean: boolean) => {
    await modal.current?.dismiss();
    setcancelModal(false);
  };

  const dismissErrorModal = async (isGoBack: boolean) => {
    setErrorModal(false);
    setIsAlreadyClicked(false);

    if (isGoBack) {
      if (isEdit) {
        history.goBack();
      } else {
        history.replace("/home");
      }
    }
  };

  const updateStateLookUp = async () => {
    await initializeAllArrays();
  };

  const mobileInputCheck = (e: Event) => {
    clearErrors("mobilePhone");
    const re = /^[0-9\b\-]+$/;
    if (
      (e.target as HTMLInputElement).value === "" ||
      re.test((e.target as HTMLInputElement)?.value)
    ) {
      if ((e.target as HTMLInputElement).value.length <= 13) {
        if (
          (e.target as HTMLInputElement).value.length == 3 &&
          patientDetails?.mobilePhone?.indexOf("-") == -1
        ) {
          (e.target as HTMLInputElement).value =
            (e.target as HTMLInputElement)?.value + "-";
        } else if (
          (e.target as HTMLInputElement).value.length == 7 &&
          patientDetails?.mobilePhone?.lastIndexOf("-") == 3
        ) {
          (e.target as HTMLInputElement).value =
            (e.target as HTMLInputElement)?.value + "-";
        }
        setPatientDetails((prevState: any) => ({
          ...prevState,
          mobilePhone: (e.target as HTMLInputElement)?.value,
        }));
      } else {
        setPatientDetails((prevState: any) => ({
          ...prevState,
          mobilePhone: (e.target as HTMLInputElement)?.value,
        }));
        ((e.target as HTMLInputElement).value as String) =
          patientDetails?.mobilePhone as String;
      }
    } else {
      setError("mobilePhone", {
        type: "pattern",
        message: "Phone Number Must be in Numeric",
      });
      // e.target.value = e.target.value.slice(0, -1);
    }
  };

  const updateList = (option: Option, tagName: String) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    let deSelectTagsOrDiagnosis: Option[] = [];

    if (tagName == "Tags") {
      deSelectTagsOrDiagnosis = newAllDropDown.tags.filter(
        (obj: Option) => obj.id != option.id,
      );
    } else if (tagName == "Diagnosis") {
      deSelectTagsOrDiagnosis = newAllDropDown.diagnosis.filter(
        (obj: Option) => obj.id != option.id,
      );
    } else if (tagName == "Medications") {
      deSelectTagsOrDiagnosis = newAllDropDown.medications.filter(
        (obj: Option) => obj.id != option.id,
      );
    }

    setNewAllDropDown((lp: PatientFormDropdowns) => {
      return {
        ...lp,
        [tagName.toLowerCase()]: [...deSelectTagsOrDiagnosis],
      };
    });

    if ((tagName = "Tags")) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        tagIds: [
          ...deSelectTagsOrDiagnosis.map((opt: Option) => {
            return opt.id;
          }),
        ],
      }));
    } else if (tagName == "Diagnosis") {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        diagnosisIds: [
          ...deSelectTagsOrDiagnosis.map((opt: Option) => {
            return opt.id;
          }),
        ],
      }));
    } else if (tagName == "Medications") {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        medicationIds: [
          ...deSelectTagsOrDiagnosis.map((opt: Option) => {
            return opt.id;
          }),
        ],
      }));
    }
  };

  async function SaveRecentSearch(
    fullName: string,
    patientid: number,
    dob: string,
  ) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      await SaveRecentSearchAuth({
        loggedInUserID: 0,
        search: {
          fullName: fullName,
          patientid: patientid,
          dob: dob,
        },
      }).catch((error) => {
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  async function RegisterPatientStep2(data: any) {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setApiReqSent(true);

    let localDateTime = CurrDatetimeInNewFormat(
      new Date(selectedYear, selectedMonth - 1, selectedDay),
    );

    seterrorStringDisplay("");
    // "selectedSetting" new state created to handle the setting dropdown value issue after editing referral
    //TODO: need to find its root cause

    let patient = new PatientVM();
    patient.id = isEdit ? Number(localStorage.getItem("patientServerID")) : 0;
    patient.firstName = data.firstName;
    patient.lastName = data.lastName;
    patient.nickName = data.nickName;
    patient.email = data.email;
    patient.dob = localDateTime;
    patient.zip = data.zip;
    patient.patientSetting =
      newAllDropDown?.setting == undefined
        ? selectedSetting.id
        : newAllDropDown?.setting.id;
    patient.referralId = newAllDropDown.referral?.id;
    patient.followUpTypeId = newAllDropDown.followUpType?.id;
    patient.physicianId = newAllDropDown.physician?.id;
    patient.departmentId = newAllDropDown.department?.id;
    patient.tagIds = newAllDropDown.tags.map((Item: Option) => Item.id);
    patient.diagnosisIds = newAllDropDown.diagnosis.map(
      (Item: Option) => Item.id,
    );
    patient.isTestPatient = isTestPatient;
    patient.mobilePhone =
      data.mobilePhone == null || data.mobilePhone == undefined
        ? ""
        : data.mobilePhone.replace(/\D/g, "");
    patient.sex = 0;
    patient.city = "";
    patient.mrn = data.mrn;
    patient.medicationIds = newAllDropDown.medications.map(
      (Item: Option) => Item.id,
    );
    patient.isPatientRTMEnabled = data.isRTMEnabled;

    // Round-trip the integration fields so the server keeps the link to the
    // external record (these drive the locked fields on the edit screen)
    if (isEdit) {
      patient.externalPatientId = patientDetails?.externalPatientId ?? 0;
      patient.integrationExternalPendingId =
        patientDetails?.integrationExternalPendingId ?? null;
      patient.integrationExternalApprovedId =
        patientDetails?.integrationExternalApprovedId ?? 0;
      patient.integrationStatus = patientDetails?.integrationStatus ?? null;
      patient.notes = patientDetails?.notes ?? null;
      patient.roomNumber = patientDetails?.roomNumber ?? null;
    }

    localStorage.setItem("patientdob", localDateTime);
    try {
      await RegisterPatientAuth({
        patient: { ...patient!, referralSourceId: patient!.referralId },
        localDateTime: new Date(),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
      })
        .then(async function (response) {
          setIsAlreadyClicked(false);
          if (response!.data.isResponseSuccessfull) {
            setDropDownStateToSave(newAllDropDown);
            seterrorStringDisplay("");
            if (isEdit) {
              let latestFullName = patient.firstName + " " + patient.lastName;
              let lastFullName = localStorage.getItem("fullName");
              if (latestFullName != lastFullName) {
                // now sending this call from API
                // SaveRecentSearch(latestFullName, patient.id, patient.dob);
              }
              history.replace("/confirmation", {
                actionType: ActionType.SuccessUpdatePatient,
              });
            } else {
              localStorage.setItem("patientServerID", response!.data.id);
              localStorage.setItem("patientMasterID", response!.data.id);
              let latestFullName = patient.firstName + " " + patient.lastName;
              localStorage.setItem("patientName", latestFullName);
              history.replace("/confirmation", {
                actionType: ActionType.SuccessCreatePatient,
              });
            }
          } else {
            setNewAllDropDown((prevState: PatientFormDropdowns) => ({
              ...prevState,
              ...newAllDropDownState,
            }));
            if (
              response!.data.responseMessage !== "" &&
              response!.data.responseMessage !== null
            ) {
              setApiReqSent(false);

              if (
                response!.data.responseMessage.includes(
                  "Patient already exists",
                )
              ) {
                localStorage.setItem(
                  "patientMasterIDAlreadyExist",
                  response!.data.masterPatientId,
                );
                localStorage.setItem(
                  "patientWorkstationID",
                  response!.data.patientWorkstationId,
                );
                localStorage.setItem("isPatientAlreadyExistFlow", "true");
                seterrorStringDisplay("");
                setPatientExitModal(true);
              } else if (
                response!.data.responseMessage.includes("Email already exists")
              ) {
                // localStorage.setItem("patientServerID", response!.data.id);
                seterrorStringDisplay(response!.data.responseMessage);
                setNewAllDropDown((prevState: PatientFormDropdowns) => ({
                  ...prevState,
                  ...newAllDropDownState,
                }));
              }
            } else if (response!.data.errorMessage !== "") {
              setApiReqSent(false);
              seterrorStringDisplay(response!.data.errorMessage);
            }

            setTimeout(() => {
              seterrorStringDisplay("");
            }, 5000);
          }
        })
        .catch((error) => {
          setApiReqSent(false);
          localStorage.setItem(
            "actionType",
            ActionType.FailureAPIResponse.toString(),
          );
        });
    } catch (error) {
      setApiReqSent(false);
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }

  const requiredInfoError = () => {
    if (
      errors?.firstName?.type === "required" ||
      errors?.lastName?.type === "required" ||
      errors?.settingFormField?.type === "required" ||
      errors?.zip?.type === "required" ||
      errors?.dob?.type === "required" ||
      errors?.dobFormatted?.type === "required"
    ) {
      return "Missing Information";
    }

    if (
      errors?.firstName?.type === "pattern" ||
      errors?.lastName?.type === "pattern" ||
      errors?.settingFormField?.type === "pattern" ||
      errors?.zip?.type === "pattern" ||
      errors?.dob?.type === "pattern" ||
      errors?.dobFormatted?.type === "pattern"
    ) {
      return "Invalid Information";
    }

    return "";
  };

  const additionalInfoError = () => {
    if (errors?.email?.type === "pattern" || errors?.mrn?.type === "pattern") {
      return "Invalid Information";
    }

    return "";
  };

  const enableDisablePatientRtm = async (
    isNewEpisode: boolean,
    isRtmReenable: boolean,
  ) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      await EnableDisablePatientRtm({
        PatientId: localStorage.getItem("patientServerID"),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
        IsPatientRTMEnabled: !patientDetails?.isPatientRTMEnabled,
        LocalDateTime: localDateTime(),
        IsNewEpisode: isNewEpisode,
        IsRtmReenable: isRtmReenable,
        MasterUserId: JSON.parse(localStorage.getItem("patientMasterID")!),
        MobilePhone: localStorage.getItem("patientMobileNumber") ?? "",
      }).then(async function (response: any) {
        console.log("Response: ", response);
        if (response?.data?.dbResponse?.id > 0) {
          let status;
          if (!patientDetails?.isPatientRTMEnabled) {
            status = "true";
          } else {
            status = "false";
          }
          sessionStorage.setItem("isPatientRtmTrue", status);
          sessionStorage.setItem(
            "patientDetails",
            JSON.stringify(patientDetails),
          );
          if (!patientDetails?.isPatientRTMEnabled) {
            setPatientDetails((prevState: PatientVM) => ({
              ...prevState,
              isRtmEverEnabled: true,
            }));
            setPatientDetailsRecoil((prevState: PatientVM) => ({
              ...prevState,
              isRtmEverEnabled: true,
            }));
            // setPatientInformation((prevState: any) => ({
            //   ...prevState,
            //   isRtmEverEnabled: true,
            // }));
          }
          handleEducationClose();
        }
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  //RTM Toggle
  const handleRtmToggle = async () => {
    console.log(
      "patientDetails?.isPatientRTMEnabled",
      patientDetails?.isPatientRTMEnabled,
    );
    if (patientDetails?.isPatientRTMEnabled) {
      setRemoteTherapeuticMonitoring(true);
    } else {
      if (patientDetails?.isRtmEverEnabled) {
        setIsRtmReenable(true);
        setChooseEpisode(true);
        //await enableDisablePatientRtm();
      } else {
        setIsRtmReenable(false);
        setConsentForm(true);
      }
    }
  };

  const handleConsentClose = async () => {
    setConsentForm(false);
    setIsRtmReenable(false);
    setIsNewEpisode(true);
    setChooseEpisode(false);
    await enableDisablePatientRtm(true, false);
    const isSFTPPatient =
      localStorage.getItem("isSFTPPatient") === "true" ? true : false;
    if (isSFTPPatient || true) {
      handleEducationClose();
    } else {
      setCompletedEducation(true);
    }
  };

  const handleConsentFormObject = (data: any) => {
    debugger;
    console.log("Received from ConsentFormModal:", data);
    setIsNewEpisode(true);
    setConsentFormData(data);
    setConsentForm(false);
    setSetupEpisode(true);

    //Setting recoil state
    setPatientDetails((prevState: any) => ({
      ...prevState,
      email: data?.Email,
      mobilePhone: data?.MobilePhone,
    }));
    // Open the SetupEpisode modal immediately
  };

  const handleSetupEpisodeClose = async () => {
    setIsRtmReenable(false);
    setIsNewEpisode(true);
    setChooseEpisode(false);
    await enableDisablePatientRtm(true, false);
    handleEducationClose();
  };

  const handleChooseEpisodeClose = async () => {
    setIsNewEpisode(false);
    setIsRtmReenable(false);
    setChooseEpisode(false);
    await enableDisablePatientRtm(false, true);
    handleEducationClose();
  };

  const handleNewEpisodeClose = async () => {
    setIsNewEpisode(true);
    setIsRtmReenable(true);
    setNewEpisode(false);
    await enableDisablePatientRtm(true, true);
    handleEducationClose();
  };

  const handleEducationClose = () => {
    setCompletedEducation(false);
    setRtmEnabled(true);
    setOpenRtmModal(true);
  };

  const handleDisableConsentClose = () => {
    setRemoteTherapeuticMonitoring(false);
    setRtmEnabled(false);
    setOpenRtmModal(true);
  };

  const handleEnableDisableModalClose = (isEnabled: boolean) => {
    setOpenRtmModal(false);
    if (!isEnabled) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
    } else {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
      }));
      history.push("/full-visit-summary", {
        patientInfo: patientDetails,
      });
    }
  };

  // console.log("errors", errors);

  const handleSkipExercisePlan = (isEnabled: boolean) => {
    console.log("Skip clicked");
    setOpenRtmModal(false);
    if (!isEnabled) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
    } else {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
      }));
    }
    setOpenProactiveAfterClose(true); // ONLY set when skip is clicked
    localStorage.removeItem("exercisePlan");
  };

  const handleRegisterPatient = () => {
    debugger;
    console.log("Register Patient clicked");
    setProactiveYouModal(false);
    setRegisterPatientModal(true);
  };

  const handleCloseRegistrationModal = async () => {
    setRegisterPatientModal(false);

    // Refresh patient details to get updated RTM status
    // await GetPatientVisitDetails();
  };

  return (
    <>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={RemoteTherapeuticMonitoring}
        placeholder={undefined}
      >
        <RemoteTherapeuticMonitoringModal
          setRemoteTherapeuticMonitoring={setRemoteTherapeuticMonitoring}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          onClose={handleDisableConsentClose}
        ></RemoteTherapeuticMonitoringModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={openRtmModal}
        placeholder={undefined}
        onDidDismiss={() => {
          if (openProactiveAfterClose) {
            console.log("Opening ProactiveYou modal now...");
            setProactiveYouModal(true);
            setOpenProactiveAfterClose(false); // reset flag
          }
        }}
      >
        <RtmEnabledModal
          enabled={RtmEnabled}
          onClose={handleEnableDisableModalClose}
          onSkip={handleSkipExercisePlan}
        ></RtmEnabledModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={registerPatientModal}
        placeholder={undefined}
      >
        <PatientRegistrationQRModal
          setRegisterPatientModal={handleCloseRegistrationModal}
          patientData={{
            masterPatientId: Number(localStorage.getItem("masterUserId")) || 0,
            email: patientDetails?.email,
            mobilePhone: patientDetails?.mobilePhone,
            firstName: patientDetails?.firstName,
            lastName: patientDetails?.lastName,
            fullName:
              patientDetails?.firstName + " " + patientDetails?.lastName,
            patientName:
              patientDetails?.firstName + " " + patientDetails?.lastName,
            dob: patientDetails?.dob,
            DOB: patientDetails?.dob,
            FirstName: patientDetails?.firstName,
            LastName: patientDetails?.lastName,
            PatientLocationId: patientDetails?.patientLocationId,
          }}
          isCalledAfterRtmEnabled={true}
          onError={(message) => {
            seterrorStringDisplay(message);
          }}
        />
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={proactiveYouModal}
        placeholder={undefined}
      >
        <ProactiveYouModal
          HideProactiveModal={setProactiveYouModal}
          onRegisterPatient={handleRegisterPatient}
        />
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={CompletedEducation}
        placeholder={undefined}
      >
        <CompletedEducationModal
          setCompletedEducation={setCompletedEducation}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          onClose={handleEducationClose}
        ></CompletedEducationModal>
      </IonModal>

      <IonModal
        className="overall-center-modal-main-wrap"
        backdropDismiss={false}
        isOpen={cancelModal}
        placeholder={undefined}
      >
        <ExitModal
          setShowModal1={setcancelModal}
          actionType={
            isEdit ? ActionType.ExitPatientSetup : ActionType.CreateNewPatient
          }
          reset={reset}
          isEdit={isEdit}
        ></ExitModal>
      </IonModal>

      <IonModal
        className="overall-center-modal-main-wrap"
        backdropDismiss={false}
        isOpen={patientExitModal}
        placeholder={undefined}
      >
        <PatientExistModal
          setShowModal1={setPatientExitModal}
          actionType={ActionType.PatientAlreadyExist}
          reset={reset}
          isEdit={isEdit}
        ></PatientExistModal>
      </IonModal>

      <IonModal
        className="create-tag-modal"
        backdropDismiss={false}
        isOpen={lookUpOption}
        placeholder={undefined}
      >
        <CreateNewLookup
          setIsLookupUpdated={updateStateLookUp}
          setShowModal2={setLookUpOption}
          LookUpType={lookUpType}
        />
      </IonModal>

      <IonModal
        className="all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={errorModal}
        placeholder={undefined}
      >
        <SuccessModal
          setShowModal={dismissErrorModal}
          actionType={ActionType.ErrorEditPatient}
        ></SuccessModal>
      </IonModal>

      <IonModal
        backdropDismiss={false}
        className="consent-form-modal-wrap"
        isOpen={ConsentForm}
        placeholder={undefined}
      >
        <ConsentFormModal
          setConsentForm={setConsentForm}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          phoneNumber={patientDetails?.mobilePhone ?? ""}
          email={patientDetails?.email ?? ""}
          onClose={handleConsentClose}
          consentFormObjectPassToParent={handleConsentFormObject}
        ></ConsentFormModal>
      </IonModal>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={SetupEpisode}
        placeholder={undefined}
      >
        <SetupEpisodeModal
          setSetupEpisode={setSetupEpisode}
          consentFormData={consentFormData}
          onClose={handleSetupEpisodeClose}
          rtmStartDate={
            consentFormData?.StartDate
              ? new Date(consentFormData.StartDate).toLocaleDateString("en-US")
              : undefined
          }
        ></SetupEpisodeModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={NewEpisode}
        placeholder={undefined}
      >
        <NewEpisodeModal
          setNewEpisode={setNewEpisode}
          onClose={handleNewEpisodeClose}
          rtmStartDate={
            patientDetails?.rtmStartDate
              ? format(new Date(patientDetails.rtmStartDate), "MM/dd/yyyy")
              : undefined
          }
        ></NewEpisodeModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        onDidDismiss={() => setChooseEpisode(false)}
        isOpen={ChooseEpisode}
        placeholder={undefined}
      >
        <ChooseEpisodeModal
          setChooseEpisode={setChooseEpisode}
          setNewEpisode={setNewEpisode}
          onClose={handleChooseEpisodeClose}
          isOpen={ChooseEpisode}
          rtmStartDate={
            patientDetails?.rtmStartDate
              ? format(new Date(patientDetails.rtmStartDate), "MM/dd/yyyy")
              : undefined
          }
        ></ChooseEpisodeModal>
      </IonModal>

      <form
        onSubmit={handleSubmit(
          (data) => {
            RegisterPatientStep1(data);
          },
          (errorsRes) => {
            if (
              errorsRes?.firstName?.type === "required" ||
              errorsRes?.lastName?.type === "required" ||
              errorsRes?.settingFormField?.type === "required" ||
              errorsRes?.zip?.type === "required" ||
              errorsRes?.dob?.type === "required" ||
              errorsRes?.dobFormatted?.type === "required"
            ) {
              setErrorModal(true);
            }
          },
        )}
        autoComplete="off"
      >
        {errorStringDisplay != null && errorStringDisplay != "" ? (
          <ErrorTopToaster errorString={errorStringDisplay} />
        ) : (
          ""
        )}

        <IonPage placeholder={undefined}>
          <IonHeader className="ion-no-border" placeholder={undefined}>
            <TopLeftUserName
              headerText={isEdit ? "Edit Patient" : "Create New Patient"}
            ></TopLeftUserName>
          </IonHeader>
          <IonContent placeholder={undefined} className="slide-in-right">
            <IonGrid className="container" placeholder={undefined}>
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <div className="new-create-patient">
                    <>
                      <div
                        className={`accordian ${
                          selectedAccordionValue === "requiredInfo"
                            ? "active"
                            : ""
                        }`}
                      >
                        <div
                          className="accordian-header-wrap first-child"
                          onClick={() => handleAccordionChange("requiredInfo")}
                        >
                          <div className="accordian-header">Patient Info</div>
                          {isOpenRequired ? (
                            <div className="toggleIconOpen">
                              <span className="missing-info-text">
                                {requiredInfoError()}
                              </span>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15 5.5L9 11.5L3 5.5"
                                  stroke="#005A75"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          ) : (
                            <div className="toggleIconClose">
                              <span className="missing-info-text">
                                {requiredInfoError()}
                              </span>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3 12.5L9 6.5L15 12.5"
                                  stroke="#005A75"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          )}
                        </div>

                        <div
                          className={`accordian-body ${
                            !isOpenRequired && "d-none"
                          }`}
                          slot="content"
                        >
                          {rtmEnabledRef.current && isEdit && (
                            <div className="rtm-wrap d-flex justify-content-between mb-24">
                              <div className="d-flex align-items-center gap-10">
                                <IonLabel
                                  className="label mb-0 fz-24"
                                  placeholder={undefined}
                                >
                                  Remote Therapeutic Monitoring
                                </IonLabel>
                                <input
                                  type="hidden"
                                  {...register("isPatientRTMEnabled")}
                                  value={
                                    patientDetails.isPatientRTMEnabled
                                      ? "true"
                                      : "false"
                                  }
                                />
                                <div
                                  className={`rtm-checkbox-wrap disabled ${
                                    patientDetails.isPatientRTMEnabled
                                      ? "enabled"
                                      : "disabled"
                                  }`}
                                >
                                  {patientDetails.isPatientRTMEnabled
                                    ? "Enabled"
                                    : "Disabled"}
                                </div>
                              </div>
                              {(!patientDetails?.isSFTPEhrImportEnabled ||
                                patientDetails?.externalPatientId !== 0) && (
                                <button
                                  type="button"
                                  className="generic-text-btn"
                                  onClick={handleRtmToggle}
                                >
                                  {patientDetails.isPatientRTMEnabled
                                    ? "Disable RTM"
                                    : "Enable RTM"}
                                </button>
                              )}
                            </div>
                          )}

                          <div
                            className={`field-wrap ${
                              errors.firstName && "error-wrap"
                            }`}
                          >
                            <IonLabel className="label" placeholder={undefined}>
                              First Name *
                            </IonLabel>

                            <IonInput
                              className="input-field"
                              type="text"
                              placeholder="Enter First Name"
                              disabled={disableIdentityFields}
                              onIonChange={(e: any) => {
                                namingtValidation(e, "firstName");
                              }}
                              {...register("firstName", {
                                required: true,
                              })}
                            ></IonInput>

                            {errors?.firstName?.type === "validate" && (
                              <p className="error-msg">
                                {errors.firstName.message}
                              </p>
                            )}
                            {errors?.firstName?.type === "required" && (
                              <p className="error-msg">
                                This field is required
                              </p>
                            )}
                            {errors?.firstName?.type === "pattern" && (
                              <p className="error-msg">
                                First Name should start with alphanumeric
                              </p>
                            )}
                            {errors.firstName &&
                              errors.firstName.type !== "required" &&
                              errors.firstName.type === "server" &&
                              errors.firstName.message && (
                                <p>
                                  This error is added in the first name server
                                  error
                                </p>
                              )}
                          </div>

                          <div
                            className={`field-wrap ${
                              errors.lastName && "error-wrap"
                            }`}
                          >
                            <IonLabel className="label" placeholder={undefined}>
                              Last Name *
                            </IonLabel>

                            <IonInput
                              className="input-field"
                              type="text"
                              placeholder="Enter Last Name"
                              disabled={disableIdentityFields}
                              onIonChange={(e: any) => {
                                namingtValidation(e, "lastName");
                              }}
                              {...register("lastName", {
                                required: true,
                              })}
                            ></IonInput>

                            {errors?.lastName?.type === "validate" && (
                              <p className="error-msg">
                                {errors.lastName.message}
                              </p>
                            )}
                            {errors?.lastName?.type === "required" && (
                              <p className="error-msg">
                                This field is required
                              </p>
                            )}
                            {errors?.lastName?.type === "pattern" && (
                              <p className="error-msg">
                                Last Name should start with alphanumeric
                              </p>
                            )}
                            {errors.lastName &&
                              errors.lastName.type !== "required" &&
                              errors.lastName.type === "server" &&
                              errors.lastName.message && (
                                <p>
                                  This error is added in the last name server
                                  error
                                </p>
                              )}
                          </div>

                          <div
                            className={`field-wrap ${
                              (errors.dobFormatted || errors.dob) &&
                              "error-wrap"
                            }`}
                          >
                            <IonLabel className="label" placeholder={undefined}>
                              Date of Birth*
                            </IonLabel>
                          </div>

                          {/* Start of New Date of Birth Field */}
                          <div className="custom-dob-wrap field-wrap">
                            <div className="d-flex justify-content-between gap-20">
                              <div
                                className={`custom-dropdown-wrap ${
                                  isMonthOpen ? "open" : ""
                                } ${
                                  !isValidDate && !isFirstTime
                                    ? "error-wrap"
                                    : ""
                                } ${disableIdentityFields ? "dropdown-locked" : ""}`}
                                onClick={
                                  disableIdentityFields
                                    ? undefined
                                    : toggleMonthDropdown
                                }
                                ref={dropdownMonthRef}
                              >
                                <IonLabel
                                  className="label"
                                  placeholder={undefined}
                                >
                                  Month
                                </IonLabel>

                                <div className="dropdown-input input-field">
                                  {selectedMonth === 0
                                    ? "Jul"
                                    : months[selectedMonth - 1].label}
                                </div>

                                <div className="dropdown-item-wrap">
                                  {months.map((month) => (
                                    <div
                                      key={month.value}
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleMonthChange(month.value)
                                      }
                                    >
                                      {month.label}
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <div
                                className={`custom-dropdown-wrap ${
                                  isDayOpen ? "open" : ""
                                } ${
                                  !isValidDate && !isFirstTime
                                    ? "error-wrap"
                                    : ""
                                } ${disableIdentityFields ? "dropdown-locked" : ""}`}
                                onClick={
                                  disableIdentityFields
                                    ? undefined
                                    : toggleDayDropdown
                                }
                                ref={dropdownDayRef}
                              >
                                <IonLabel
                                  className="label"
                                  placeholder={undefined}
                                >
                                  Day
                                </IonLabel>

                                <div className="dropdown-input input-field">
                                  {selectedDay === 0 ? "1" : selectedDay}
                                </div>

                                <div className="dropdown-item-wrap">
                                  {days.map((day) => (
                                    <div
                                      key={day}
                                      className="dropdown-item"
                                      onClick={() => handleDayChange(day)}
                                    >
                                      {day}
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <div
                                className={`custom-dropdown-wrap ${
                                  isYearOpen ? "open" : ""
                                } ${
                                  !isValidDate && !isFirstTime
                                    ? "error-wrap"
                                    : ""
                                } ${disableIdentityFields ? "dropdown-locked" : ""}`}
                                onClick={
                                  disableIdentityFields
                                    ? undefined
                                    : toggleYearDropdown
                                }
                                ref={dropdownYearRef}
                              >
                                <IonLabel
                                  className="label"
                                  placeholder={undefined}
                                >
                                  Year
                                </IonLabel>

                                <div className="dropdown-input input-field">
                                  {selectedYear === 0 ? "1960" : selectedYear}
                                </div>

                                <div className="dropdown-item-wrap">
                                  {years.map((year) => (
                                    <div
                                      key={year}
                                      className="dropdown-item"
                                      onClick={() => handleYearChange(year)}
                                    >
                                      {year}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                            {!isValidDate && !isFirstTime && (
                              <h6 style={{ color: "red" }}>
                                Please select a valid date.
                              </h6>
                            )}
                          </div>
                          {/* End of New Date of Birth Field */}

                          <div
                            className={`field-wrap ${
                              (dropDownErros.setting ||
                                errors.settingFormField) &&
                              "error-wrap"
                            } `}
                          >
                            <IonLabel className="label" placeholder={undefined}>
                              Setting *
                            </IonLabel>

                            <SelectSelectionCustom
                              isEdit={isEdit}
                              placeholder="Select Setting"
                              isSearchable={false}
                              isEditableOption={false}
                              allOptions={savedDropDowns.settingOpt}
                              value={
                                savedDropDowns.setting?.id != undefined
                                  ? savedDropDowns.setting.name
                                  : ""
                              }
                              LookUpType={"Setting"}
                              onSelectOption={dropDownSelections}
                              onAddOrEditLookUp={() => {}}
                              isMultiSelect={false}
                              {...selectProps}
                            />
                            {/* {dropDownErros.setting && (
                              <p className="error-msg">Setting is mandatory.</p>
                            )} */}
                            {(dropDownErros.setting ||
                              (errors.settingFormField &&
                                errors.settingFormField?.type ===
                                  "required")) && (
                              <p className="error-msg">Setting is mandatory.</p>
                            )}
                          </div>

                          {/* Zip Code*/}
                          <div
                            className={`field-wrap ${
                              errors.zip && "error-wrap"
                            }`}
                          >
                            <IonLabel className="label" placeholder={undefined}>
                              Zip Code *
                            </IonLabel>

                            <IonInput
                              className="input-field"
                              type="text"
                              placeholder="Enter Zip Code"
                              onIonChange={(e: any) => {
                                inputNumberVerify(e, "zip");
                                setPatientDetails((prevState: any) => ({
                                  ...prevState,
                                  zip: e.target.value,
                                }));
                              }}
                              {...register("zip", {
                                required: true,
                                pattern: /^\d+$/,
                              })}
                            ></IonInput>
                            {errors?.zip?.type === "required" && (
                              <p className="error-msg">
                                This field is required
                              </p>
                            )}
                            {errors.zip &&
                              errors.zip.type !== "required" &&
                              errors.zip.type === "pattern" && (
                                <p className="error-msg">
                                  Zip Code must be numeric
                                </p>
                              )}
                          </div>

                          {/* Start of Follow Up Type field Section */}
                          <div className="field-wrap">
                            <IonLabel className="label" placeholder={undefined}>
                              Current Status
                            </IonLabel>
                            <SelectSelectionCustom
                              isEdit={isEdit}
                              placeholder="Select Current Status"
                              isSearchable={false}
                              isEditableOption={false}
                              allOptions={savedDropDowns?.followUpTypesOpt}
                              value={
                                savedDropDowns?.followUpType?.id != undefined
                                  ? savedDropDowns?.followUpType?.name
                                  : ""
                              }
                              LookUpType={"FollowUpType"}
                              onSelectOption={dropDownSelections}
                              onAddOrEditLookUp={() => {}}
                              isMultiSelect={false}
                            />
                          </div>
                          {/* End of Follow Up Type field Section */}
                        </div>
                      </div>

                      {/* Additional Info Accrodion Start*/}
                      <div
                        className={`accordian ${
                          selectedAccordionValue === "additionalInfo"
                            ? "active"
                            : ""
                        }`}
                      >
                        <div
                          className="accordian-header-wrap"
                          onClick={() =>
                            handleAccordionChange("additionalInfo")
                          }
                        >
                          <div className="accordian-header">Medical Info</div>
                          {isOpenAdditional ? (
                            <div className="toggleIconOpen">
                              <span className="missing-info-text">
                                {additionalInfoError()}
                              </span>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15 5.5L9 11.5L3 5.5"
                                  stroke="#005A75"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          ) : (
                            <div className="toggleIconClose">
                              <span className="missing-info-text">
                                {additionalInfoError()}
                              </span>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3 12.5L9 6.5L15 12.5"
                                  stroke="#005A75"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          )}
                        </div>

                        <div
                          className={`accordian-body ${
                            !isOpenAdditional && "d-none"
                          }`}
                          slot="content"
                        >
                          <div className="field-wrap">
                            <div className="input-field input-checkbox">
                              <IonCheckbox
                                className="checkbox-generic test-patient-checkbox"
                                checked={isTestPatient}
                                onIonChange={(e) => {
                                  setisTestPatient(e.detail.checked);
                                  setPatientDetails((prevState: any) => ({
                                    ...prevState,
                                    isTestPatient: e.detail.checked,
                                  }));
                                }}
                                placeholder={undefined}
                              />
                              <IonLabel
                                class="test-patient"
                                placeholder={undefined}
                              >
                                Test Patient
                              </IonLabel>
                            </div>
                          </div>
                          {/* End of Test Patient field Section */}

                          {/* Start of Email field section */}
                          <div
                            className={`field-wrap ${
                              errors.email && "error-wrap"
                            }`}
                          >
                            <IonLabel className="label" placeholder={undefined}>
                              Email
                            </IonLabel>

                            <IonInput
                              className="input-field"
                              type="text"
                              placeholder="Enter Email"
                              disabled={disableIntegrationOnlyFields}
                              onIonChange={(e: any) => {
                                clearErrors("email");
                                setPatientDetails((prevState: any) => ({
                                  ...prevState,
                                  email: e.target.value,
                                }));
                              }}
                              {...register("email", {
                                required: false,
                                pattern:
                                  /^[\w+,]+(?:[.-][\w+,]+)*@\w+(?:[.-]\w+)*\.\w{2,3}$/i,
                              })}
                            ></IonInput>

                            {errors?.email?.type === "pattern" && (
                              <p className="error-msg">Invalid email</p>
                            )}

                            {errors.email &&
                              errors.email.type !== "required" &&
                              errors.email.type === "server" &&
                              errors.email.message && (
                                <p className="error-msg">invalid Email</p>
                              )}
                          </div>
                          {/* End of Email field section */}

                          {/* Start of Physician field section */}
                          <div className="field-wrap">
                            <IonLabel className="label" placeholder={undefined}>
                              Physician
                            </IonLabel>
                            <SelectSelectionCustom
                              isEdit={isEdit}
                              placeholder="Search & Add Physicians"
                              isSearchable={true}
                              isEditableOption={true}
                              allOptions={savedDropDowns?.physicianOpt}
                              value={
                                savedDropDowns?.physician?.id != undefined
                                  ? savedDropDowns?.physician?.name
                                  : ""
                              }
                              // value={
                              //   newAllDropDown?.physician?.id != undefined
                              //     ? newAllDropDown?.physician?.name
                              //     : ""
                              // }
                              LookUpType={"Physician"}
                              onSelectOption={dropDownSelections}
                              onAddOrEditLookUp={setLookUp}
                              isMultiSelect={false}
                            />
                          </div>
                          {/* End of Physician field section */}

                          {/* Start of Referral field Section */}
                          <div className="field-wrap">
                            <IonLabel className="label" placeholder={undefined}>
                              Patient Referral
                            </IonLabel>
                            <SelectSelectionCustom
                              isEdit={isEdit}
                              placeholder="Search & Add Patient Referral"
                              isSearchable={true}
                              isEditableOption={true}
                              allOptions={savedDropDowns?.referralOpt}
                              value={
                                savedDropDowns?.referral?.id != undefined
                                  ? savedDropDowns?.referral?.name
                                  : ""
                              }
                              LookUpType={"Referral"}
                              onSelectOption={dropDownSelections}
                              onAddOrEditLookUp={setLookUp}
                              isMultiSelect={false}
                            />
                          </div>
                          {/* End of Referral field Section */}

                          {/* Start of Department field Section */}
                          <div className="field-wrap">
                            <IonLabel className="label" placeholder={undefined}>
                              Departments
                            </IonLabel>
                            <SelectSelectionCustom
                              isEdit={isEdit}
                              placeholder="Search & Add Departments"
                              isSearchable={true}
                              isEditableOption={true}
                              allOptions={savedDropDowns?.departmentOpt}
                              value={
                                savedDropDowns?.department?.id != undefined
                                  ? savedDropDowns?.department?.name
                                  : ""
                              }
                              LookUpType={"Department"}
                              onSelectOption={dropDownSelections}
                              onAddOrEditLookUp={setLookUp}
                              isMultiSelect={false}
                            />
                          </div>
                          {/* End of Department field Section */}

                          {/* Start of MRN field Section */}
                          <div
                            className={`field-wrap ${
                              errors.mrn && "error-wrap"
                            }`}
                          >
                            <IonLabel className="label" placeholder={undefined}>
                              MRN
                            </IonLabel>
                            <IonInput
                              className="input-field"
                              type="text"
                              placeholder="Enter MRN"
                              onIonChange={(e: any) => {
                                inputNumberVerify(e, "mrn");
                                setPatientDetails((prevState: any) => ({
                                  ...prevState,
                                  mrn: e.target.value,
                                }));
                              }}
                              {...register("mrn", {
                                required: false,
                                maxLength: 10,
                                pattern: /^[eE]?[0-9\-_"]+$/,
                              })}
                            ></IonInput>
                            {errors?.mrn?.type === "pattern" && (
                              <p className="error-msg">
                                {errors?.mrn?.message}
                              </p>
                            )}
                            {errors.mrn &&
                              (errors.mrn.type as unknown) == "mrn" && (
                                <p className="error-msg">Invalid MRN</p>
                              )}
                          </div>
                          {/* End of MRN field Section */}

                          {/* Start of Tags field Section */}
                          <div className="field-wrap">
                            <IonLabel className="label" placeholder={undefined}>
                              Tags
                            </IonLabel>

                            <SelectSelectionCustom
                              isEdit={isEdit}
                              placeholder="Search & Add Tag"
                              isSearchable={true}
                              isEditableOption={true}
                              allOptions={savedDropDowns.tagsOpt}
                              value={""}
                              LookUpType={"Tags"}
                              onSelectOption={dropDownSelections}
                              onAddOrEditLookUp={setLookUp}
                              isMultiSelect={true}
                              selectedTags={savedDropDowns.tags}
                            />

                            <div className="select-multi-select-wrap-main">
                              <div className="select-multi-select-wrap-main-inner">
                                {savedDropDowns.tags.length
                                  ? savedDropDowns.tags.map((tag: Option) => {
                                      return (
                                        <TagsName
                                          key={tag.id}
                                          tagListName={"Tags"}
                                          tag={tag}
                                          handleSelectionData={updateList}
                                        />
                                      );
                                    })
                                  : ""}
                              </div>
                            </div>
                          </div>
                          {/* End of Tags field Section */}

                          {/* Start of Medications field Section */}
                          <div className="field-wrap">
                            <IonLabel className="label" placeholder={undefined}>
                              Medications
                            </IonLabel>

                            <SelectSelectionCustom
                              isEdit={isEdit}
                              placeholder="Search Medications"
                              isSearchable={true}
                              isEditableOption={false}
                              allOptions={savedDropDowns.medicationsOpt}
                              value={""}
                              LookUpType={"Medications"}
                              onSelectOption={dropDownSelections}
                              onAddOrEditLookUp={() => {}}
                              isMultiSelect={true}
                              selectedTags={savedDropDowns.medications}
                            />

                            <div className="select-multi-select-wrap-main">
                              <div className="select-multi-select-wrap-main-inner">
                                {savedDropDowns.medications.length
                                  ? savedDropDowns.medications.map(
                                      (medicine: Option) => {
                                        return (
                                          <TagsName
                                            key={medicine.id}
                                            tagListName={"Medications"}
                                            tag={medicine}
                                            handleSelectionData={updateList}
                                          />
                                        );
                                      },
                                    )
                                  : ""}
                              </div>
                            </div>
                          </div>
                          {/* End of Medications field Section */}

                          {/* Start of Diagnosis field Section */}
                          <div className="field-wrap">
                            <IonLabel className="label" placeholder={undefined}>
                              Diagnosis
                            </IonLabel>

                            <SelectSelectionCustom
                              isEdit={isEdit}
                              placeholder="Select Diagnosis"
                              isSearchable={true}
                              isEditableOption={false}
                              allOptions={savedDropDowns.diagnosisOpt}
                              value={""}
                              LookUpType={"Diagnosis"}
                              onSelectOption={dropDownSelections}
                              onAddOrEditLookUp={setLookUp}
                              isMultiSelect={true}
                              selectedTags={savedDropDowns.diagnosis}
                            />
                            <div className="select-multi-select-wrap-main">
                              <div className="select-multi-select-wrap-main-inner">
                                {savedDropDowns.diagnosis
                                  ? savedDropDowns.diagnosis.map(
                                      (diagnose: Option) => {
                                        return (
                                          <TagsName
                                            key={diagnose.id}
                                            tagListName={"Diagnosis"}
                                            tag={diagnose}
                                            handleSelectionData={updateList}
                                          />
                                        );
                                      },
                                    )
                                  : ""}
                              </div>
                            </div>
                          </div>
                          {/* End of Diagnosis field Section */}
                        </div>
                      </div>
                      {/* End of Additional Info Section */}
                    </>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>

          <IonFooter className="ion-no-border" placeholder={undefined}>
            <IonGrid className="container" placeholder={undefined}>
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <div className="btn-wrap-sec two-btns">
                    <IonButton
                      className="generic-btn generic-btn-outline"
                      onClick={() => {
                        setcancelModal(true);
                      }}
                      // onClick={() => {
                      //   setPatientDetails(dummyPatient);
                      //   history.push("/confirmation", {
                      //     actionType: ActionType.ExitPatientSetup,
                      //   });
                      // }}
                      disabled={cancelModal ? true : false}
                      placeholder={undefined}
                    >
                      Cancel
                    </IonButton>
                    <IonButton
                      className="generic-btn"
                      type="submit"
                      disabled={Object.keys(errors).length ? true : isDisabled}
                      placeholder={undefined}
                    >
                      Save
                    </IonButton>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonFooter>
        </IonPage>
      </form>
    </>
  );
};

export default CreateEditPatient;
